/**
 * Admin-API: Member-Einladungen (Sales / Team) - zentraler HTTP-Zugriff.
 *
 * Mit der Auth-Umstellung auf SMS-Login enthaelt jede Einladung jetzt eine
 * Telefonnummer (E.164). E-Mail bleibt optional (rein fuer den Versand des
 * Einladungslinks). Der oeffentliche Accept-Flow ist 2-stufig: erst /start
 * (SMS), dann /accept (Code + LocalPart).
 */

function authHeaders(token) {
  return { Authorization: "Bearer " + (token || "") };
}

export async function listInvitations({ apiBase, token }) {
  const r = await fetch(`${apiBase}/api/admin/members-invitations`, {
    headers: authHeaders(token),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Laden fehlgeschlagen");
  return Array.isArray(j.invitations) ? j.invitations : [];
}

export async function createInvitation({ apiBase, token, email, phone }) {
  const r = await fetch(`${apiBase}/api/admin/members-invitations`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders(token) },
    body: JSON.stringify({ email: email || null, phone, country: "DE" }),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Einladung fehlgeschlagen");
  return j;
}

export async function revokeInvitation({ apiBase, token, id }) {
  const r = await fetch(`${apiBase}/api/admin/members-invitations/${id}/revoke`, {
    method: "POST",
    headers: authHeaders(token),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Widerruf fehlgeschlagen");
  return j;
}

/** Oeffentlich (kein Admin-Token). */
export async function preflightInvite({ apiBase, token: inviteToken }) {
  const u = new URLSearchParams();
  u.set("token", inviteToken);
  const r = await fetch(
    `${apiBase}/api/public/member-invite?${u.toString()}`,
  );
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Ungueltige Einladung");
  return j; // { valid, email_masked, phone_masked, expires_at }
}

export async function checkAvailability({ apiBase, token: inviteToken, localPart }) {
  const u = new URLSearchParams();
  u.set("token", inviteToken);
  u.set("local_part", localPart);
  const r = await fetch(
    `${apiBase}/api/public/member-invite/availability?${u.toString()}`,
  );
  const j = await r.json().catch(() => ({}));
  if (r.status === 410) throw new Error(j.error || "abgelaufen");
  if (r.status === 403) return { available: false, error: j.error || "" };
  if (!r.ok) throw new Error(j.error || "Fehler");
  return j;
}

/**
 * Schritt 1 der Registrierung: SMS-Code an die in der Einladung hinterlegte
 * Telefonnummer schicken.
 */
export async function startInviteSms({ apiBase, token: inviteToken, localPart }) {
  const r = await fetch(`${apiBase}/api/public/member-invite/start`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token: inviteToken, local_part: localPart }),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "SMS konnte nicht versendet werden");
  return j; // { ok, phone_masked }
}

/**
 * Schritt 2: Code pruefen, Member-Konto anlegen, Admin-JWT zurueckgeben.
 */
export async function acceptInvite({ apiBase, token: inviteToken, localPart, code }) {
  const r = await fetch(`${apiBase}/api/public/member-invite/accept`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      token: inviteToken,
      local_part: localPart,
      code,
    }),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Registrierung fehlgeschlagen");
  return j;
}
